import { forwardRef } from "react";
import type { AnchorHTMLAttributes, ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";

type NextLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  href: string;
  prefetch?: boolean;
  replace?: boolean;
  scroll?: boolean;
  shallow?: boolean;
  passHref?: boolean;
  legacyBehavior?: boolean;
  locale?: string | false;
  children?: ReactNode;
};

const isExternal = (href: string) =>
  /^(https?:|mailto:|tel:|#)/i.test(href);

const Link = forwardRef<HTMLAnchorElement, NextLinkProps>(function Link(
  { href, replace, prefetch: _p, scroll: _s, shallow: _sh, passHref: _ph,
    legacyBehavior: _lb, locale: _l, children, ...rest },
  ref
) {
  if (!href || isExternal(href)) {
    return (
      <a ref={ref} href={href} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <RouterLink ref={ref as never} to={href} replace={replace} {...rest}>
      {children}
    </RouterLink>
  );
});

export default Link;
